import React, { useEffect, useState } from "react";
import CreditPage from "./components/Credit/Auth/CreditPage";
import Dashboard from "./components/Dashboard/Dashboard";
import RedirectToUrl from "./components/Dashboard/RedirectToURL";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import PreferredCommunicationOption from "./components/ForgotPassword/PreferredCommunicationOption";
import ResetPassword from "./components/ForgotPassword/ResetPassword";
import SecurityQuestionAnswer from "./components/ForgotPassword/SecurityQuestionAnswer";
import ValidateResetPasswordRequest from "./components/ForgotPassword/ValidateResetPasswordRequest";
import UpdateSecurityQuestion from "./components/ForgotPassword/UpdateSecurityQuestion";
import ValidatePassword from "./components/ForgotPassword/ValidatePassword";
import ForgotPasswordConfirm from "./components/ForgotPasswordConfirm";
import MonitoredInfo from "./components/IdentityVault/MonitoredInfo";
import PasswordManager from "./components/IdentityVault/PasswordManager/PasswordManager";
import SecureStorage from "./components/IdentityVault/SecureStorage/Index";
import CCPA from "./components/LegalDocumentPages/CCPA";
import CommonDefinition from "./components/LegalDocumentPages/CommonDefinition";
import EuUsGDPRPolicy from "./components/LegalDocumentPages/EuUsGDPRPolicy";
import PrivacyPolicy from "./components/LegalDocumentPages/PrivacyPolicy";
import TermsAndConditions from "./components/LegalDocumentPages/TermsAndConditions";
import Login from "./components/LoginMFA/Login";
import Logout from "./components/Logout";
import GenerateLoginMFA from "./components/LoginMFA/GeneratLoginMFA";
import VerifyLoginMFA from "./components/LoginMFA/VerifyLoginMFA";
import MyAccount from "./components/ManageAccount/MyAccount/MyAccount";
import MyServices from "./components/ManageAccount/MyServices/MyServices";
import PaymentHistory from "./components/ManageAccount/PaymentHistory";
import ProtectionPlan from "./components/ManageAccount/ProtectionPlan/ProtectionPlan";
import ActiveAlerts from "./components/Monitoring/ActiveAlerts";
import Cases from "./components/Monitoring/Cases";
import Registration from "./components/Registration/Registration";
import ReCompleteRegistration from "./components/ReCompleteRegistration/Registration";
import RegistrationError from "./components/Registration/RegistrationError";
import BreachesAndScams from "./components/Resources/BreachesAndScams";
import Calculators from "./components/Resources/Calculators";
import AutoLeaseBuyCalculator from "./components/Resources/Calculators/AutoLeaseBuyCalculator";
import CreditCardComparisonCalculator from "./components/Resources/Calculators/CreditCardComparisonCalculator";
import DebtConsolidationCalculator from "./components/Resources/Calculators/DebtConsolidationCalculator";
import LoanCalculator from "./components/Resources/Calculators/LoanCalculator";
import MortageRefinancingCalculator from "./components/Resources/Calculators/MortageRefinancingCalculator";
import MortgageQualificationCalculator from "./components/Resources/Calculators/MortgageQualificationCalculator";
import Downloads from "./components/Resources/Downloads";
import Education from "./components/Resources/Education";
import Forms from "./components/Resources/Forms/Forms";
import JunkMailAndCalls from "./components/Resources/JunkMailAndCalls";
import BreachReadiness from "./components/Resources/BreachReadiness";
import SecurityAssessment from "./components/Resources/SecurityAssessment/SecurityAssessment";
import SecurityAssessmentWizard from "./components/Resources/SecurityAssessment/SecurityAssessmentWizard";
import CyberRiskProfile from "./components/Resources/CyberRiskProfile/CyberRiskProfile";
import CyberRiskProfileWizard from "./components/Resources/CyberRiskProfile/CyberRiskProfileWizard";
import Services from "./components/Services";
import Support from "./components/Support/Support";
import GeneralSupport from "./components/Support/GeneralSupportTab";
import IncidentResponseSupport from "./components/Support/IncidentResponseSupportTab";
import BreachSupport from "./components/Support/BreachSupportTab";
import FinancialAccount from "./components/Transaction/FinancialAccount";
import CompleteFamilySetup from "./components/Family/CompleteFamilySetup";
import SwitchAccount from "./components/Family/SwitchAccount";
import Transactions from "./components/Transaction/Transactions";
import DefaultLayout from "./layouts/DefaultLayout";
import LoginLayout from "./layouts/LoginLayout";
import SocialMediaCallback from "./components/IdentityVault/MonitoringInfo/SocialMedia/SocialMediaCallback";
import GetStarted from "./components/Credit/BusinessCreditScore/GetStarted";
import BusinessSearch from "./components/Credit/BusinessCreditScore/BusinessSearch";
import BusinessCreditProfileForm from "./components/Credit/BusinessCreditScore/BusinessCreditProfileForm";
import BusinessEducation from "./components/Resources/BusinessEducation";
import Resources from "./components/Resources/Resources";
import Breaches from "./components/Breaches/Breaches";
import ActionPlan from "./components/Breaches/ActionPlan/ActionPlan";
import SearchBreaches from "./components/Breaches/SearchBreaches/SearchBreaches";
import SearchBreachesResults from "./components/Breaches/SearchBreaches/SearchBreachesResults";
import BreachDetails from "./components/Breaches/SearchBreaches/BreachDetails";
import Reputation from "./components/Reputation/Reputation";
import DataSources from "./components/Reputation/DataSources";
import Agreeableness from "./components/Reputation/Report/Agreeableness";
import Conscientiousness from "./components/Reputation/Report/Conscientiousness";
import EmotionalRange from "./components/Reputation/Report/EmotionalRange";
import Extraversion from "./components/Reputation/Report/Extraversion";
import OpennessToExperience from "./components/Reputation/Report/OpennessToExperience";
import RepIQSocialMediaCallback from "./components/Reputation/SocialMedia/SocialMediaCallback";
import Employees from "./components/Employees/Employees";
import AddEmployee from "./components/Employees/AddEmployee";
import MobileAttackView from "./components/MobileAttackView/MobileAttackView";
import RiskProtection from "./components/common/Tab/RiskProtectionTab";
import AccessRequest from "./components/MobileAttackView/AccessRequest";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import { useLocation } from "react-router-dom";

import ChildCreditActivity from "./components/ChildCreditActivity/ChildCreditActivity";

import * as ConfigurationActions from "./store/configurationService/actions";
import { ApplicationState } from "./store";
import { useDispatch, useSelector } from "react-redux";
import SSOTermsAndCondition from "./components/Dashboard/SSOTermsAndCondition";
import SystemError from "./components/Registration/SystemError";
//PSSLanding Routes
import { PssLandingRoutes } from "./PssLanding/PssLandingRoutes";
// SalesLanding Routes
import { SalesLandingRoutes } from "./SalesLanding/SalesLandingRoutes";
import { useTranslation } from "react-i18next";
import { isIDFPartnerUser } from "./util/partner";
import { useAreServicesActive } from "./util/CommonServices";
import { ezsServiceIds, idfServiceIds, isLMSComplete } from "./config/UserServicesList";
import LinkExpiry from "./components/Registration/LinkExpiry";
import MyBreachExposure from "./components/Breaches/MyBreachExposures/MyBreachExposure";
import FinancialCoaching from "./components/Resources/FinancialCoaching";
import BreachFaq from "./components/Breaches/BreachFaq";

//LandingPages Routes
import { LandingPageRoutes } from "./LandingPageTemplates/LandingPageRoutes";

export const Routes = () => {
    let currentPathLoc = useLocation();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const isPrimaryAccount: boolean = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );

    const isFrenchOnlyPartner: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            ? state.configurationState.configuration.partnerConfig.isFrenchOnlyPartner
            : false
    );
    const { i18n: i18nLang, t: tLang } = useTranslation();

    const isCCAMActive = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo?.hasCCAM ? true : false));
    const subcustomerId = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.subcustomerId
            ? state.loggedInUser.activeAccount.subcustomerId
            : ""
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
        state.configurationState.configuration.partnerConfig.partnerId &&
        state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const isIdfCCAMServiceActive = useAreServicesActive([idfServiceIds.childCreditActivityMonitoring]);

    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );
    const userInfo = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userInfo);
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const [showCreditActivity, setShowCreditActivity] = useState(false);
    const isLmsActiveService = useAreServicesActive([ezsServiceIds.businessLearningManagementSystem]);

    const getRouteKey = (pathname: string): string => {
        const path = pathname.toLowerCase();

        if (path.includes("sales_landing")) {
            return path.includes("step3")
                ? "tabTitles.salesLanding.step3"
                : "tabTitles.salesLanding.default";
        }

        if (path.includes("pss_landing")) {
            if (path.includes("provisionalresponselandingpage1"))
                return "tabTitles.pssLanding.ProvisionalResponseLandingPage1";

            if (path.includes("provisionalresponselandingpage2"))
                return "tabTitles.pssLanding.ProvisionalResponseLandingPage2";

            if (path.includes("startprotection"))
                return "tabTitles.pssLanding.StartProtection";

            if (path.includes("fraudarmor"))
                return "tabTitles.pssLanding.FraudArmor";

            if (path.includes("pssrisk"))
                return "tabTitles.pssLanding.PssRisk";

            if (path.includes("aflacregister"))
                return "tabTitles.pssLanding.AflacRegister";

            if (path.includes("aflac"))
                return "tabTitles.pssLanding.Aflac";

            if (path.includes("commercebank"))
                return "tabTitles.pssLanding.CommerceBank";

            if (path.includes("genericresponselandingpage"))
                return "tabTitles.pssLanding.GenericResponseLandingPage";

            return "tabTitles.pssLanding.default";
        }

        if (path.includes("partnerhomelogin") && path.includes("tmpl9")) {
            return "tabTitles.partnerHomeLogin.tmpl9";
        }

        return "tabTitles.default";
    };

    const normalizePathKey = (segment: string) => {
        return segment
            .toLowerCase()
            .split("-")
            .map((part, index) =>
                index === 0
                    ? part
                    : part.charAt(0).toUpperCase() + part.slice(1)
            )
            .join("");
    };


    const getTranslatedPath = (pathname: string, tLang: any): string => {
        const segments = pathname
            .slice(1)
            .split("/")
            .filter(Boolean);

        const translatedSegments = segments.map((segment) => {
            const normalizedKey = normalizePathKey(segment);
            return tLang(`paths.${normalizedKey}`, {
                defaultValue: segment
                    .replace(/-/g, " ")
                    .replace(/(?:^|\s)\S/g, (char) => char.toUpperCase())
            });
        });

        return translatedSegments.join(" | ");
    };

    const setTabTitle = () => {
        // limiting scope of this change to french only partner for now until we have more time for testing
        if (isFrenchOnlyPartner) {
            const pathname = currentPathLoc.pathname;
            const routeKey = getRouteKey(pathname);
            const translatedPath = getTranslatedPath(pathname, tLang);

            const title = tLang(routeKey, {
                partner: partnerDisplayName,
                path: translatedPath,
                defaultValue: `${partnerDisplayName} | ${translatedPath}`
            });

            document.title = title;
        } else {
            var currentPath = currentPathLoc.pathname.slice(1);
            currentPath = currentPath.replace("/", " | ");
            currentPath = currentPath.split("-").join(" ");
            currentPath = currentPath.replace(/(?:^|\s)\S/g, (res) => {
                return res.toUpperCase();
            });
            // Set TabTitle for SalesLanding Pages
            if (currentPath.toLowerCase().includes("sales_landing") === true) {
                if (currentPath.toLowerCase().includes("step3") === true) {
                    return (document.getElementsByTagName("title")[0].innerHTML = partnerDisplayName + " | Register");
                } else {
                    return (document.getElementsByTagName("title")[0].innerHTML = "Get Protected | " + partnerDisplayName); // + '®'
                }
            }
            if (currentPath.toLowerCase().includes("pss_landing") === true) {
                switch (currentPath) {
                    case "Pss_landing | ProvisionalResponseLandingPage1":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Activation");
                    case "Pss_landing | ProvisionalResponseLandingPage2":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Activation");
                    case "Pss_landing | StartProtection":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Start your Protection Today");
                    case "Pss_landing | FraudArmor":
                        return (document.getElementsByTagName("title")[0].innerHTML = "FraudArmor");
                    case "Pss_landing | PssSisk":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Activation");
                    case "Pss_landing | Aflac":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Fraud Protection");
                    case "Pss_landing | AflacRegister":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Fraud Protection Powered by EZShield");
                    case "Pss_landing | CommerceBank":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Activation");
                    case "Pss_landing | GenericResponseLandingPage":
                        return (document.getElementsByTagName("title")[0].innerHTML = "Start your Protection Today");
                    default:
                        return (document.getElementsByTagName("title")[0].innerHTML = partnerDisplayName + " | " + currentPath);
                }
            }
            if (currentPath.toLowerCase().includes("partnerhomelogin") === true) {
                if (currentPath.toLowerCase().includes("tmpl9") === true) {
                    return (document.getElementsByTagName("title")[0].innerHTML = "Fraud Protection");
                }
            } else {
                return (document.getElementsByTagName("title")[0].innerHTML = partnerDisplayName + " | " + currentPath);
            }
        }
    };

    const stopLoaderOnSalesLandingPage = () => {
        // Stop loader on SalesLanding Page
        var currentPath = currentPathLoc.pathname.slice(1);
        currentPath = currentPath.replace("/", " | ");
        currentPath = currentPath.split("-").join(" ");
        currentPath = currentPath.replace(/(?:^|\s)\S/g, (res) => {
            return res.toUpperCase();
        });
        if (currentPath.toLowerCase().includes("sales_landing") === true) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
        if (currentPath.toLowerCase().includes("pss_landing") === true) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
        if (currentPath.toLowerCase().includes("partnerhomelogin") === true) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    };

    useEffect(() => {
        dispatch(ConfigurationActions.actionCreators.setRouteLoading(true));
        setTabTitle();
        stopLoaderOnSalesLandingPage();
        setTimeout(() => {
            if (routeLoading) {
                dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
            }
        }, 5000);
    }, [partnerDisplayName, currentPathLoc.pathname]);

    useEffect(() => {
        if (!isPrimaryAccount) {
            const currentFamilyAccount = familyMembers.find((x) => x.subcustomerId === subcustomerId);
            if (currentFamilyAccount && currentFamilyAccount.showCreditActivity) {
                setShowCreditActivity(currentFamilyAccount.showCreditActivity);
            }
        }
    }, [subcustomerId]);
    let language =
        !!partnerLanguageOptions && partnerLanguageOptions.length > 1
            ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0
                ? !!document.cookie
                      .split(";")
                      .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                      .split("=")[1]
                    ? document.cookie
                          .split(";")
                          .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                          .split("=")[1]
                    : "en"
                : "en"
            : "en";
    useEffect(() => {
        if (userInfo?.preferencedLanguage) {
            document.documentElement.lang = preferencedLanguage;
        } else {
            document.documentElement.lang = language;
        }
    }, [preferencedLanguage]);

    const isCCAMServiceActive = () => {
        let isActive = false;
        if (isIDFPartner && isIdfCCAMServiceActive) {
            isActive = true;
        } else {
            isActive = isCCAMActive;
        }
        return isActive;
    };

    return (
        <React.Fragment>
            <div className={routeLoading ? "loading" : ""}>
                <DefaultLayout exact path="/" component={Login} />
                <LoginLayout exact path="/Login" component={Login} />
                <LoginLayout exact path="/Logout" component={Logout} />
                <LoginLayout exact path="/forgot-password" component={ForgotPassword} />
                <LoginLayout exact path="/forgot-password-confirm" component={ForgotPasswordConfirm} />
                <LoginLayout exact path="/complete-family-setup" component={CompleteFamilySetup} />
                <LoginLayout exact path="/security-question-answer" component={SecurityQuestionAnswer} />
                {/*Following route is being called for verify the link what being sent during password reset.*/}
                <LoginLayout exact path="/reset-password-request" component={ValidateResetPasswordRequest} />
                <LoginLayout exact path="/preferred-communication-option" component={PreferredCommunicationOption} />
                <LoginLayout exact path="/reset-password" component={ResetPassword} />
                <LoginLayout exact path="/validate-password" component={ValidatePassword} />
                <LoginLayout exact path="/update-security-question" component={UpdateSecurityQuestion} />
                <LoginLayout exact path="/generate-MFA" component={GenerateLoginMFA} />
                <LoginLayout exact path="/validate-MFA" component={VerifyLoginMFA} />
                <LoginLayout exact path="/register" component={Registration} />
                <LoginLayout exact path="/recomplete-registration" component={ReCompleteRegistration} />
                <LoginLayout exact path="/change-password" component={ChangePassword} />
                <DefaultLayout exact path="/manage-account/protection-plan" component={ProtectionPlan} />
                <DefaultLayout exact path="/switch-account" component={SwitchAccount} />
                <DefaultLayout exact path="/dashboard" component={Dashboard} />
                <DefaultLayout exact path="/redirect-to-url" component={RedirectToUrl} />
                <DefaultLayout exact path="/identity-vault" component={MonitoredInfo} />
                <DefaultLayout exact path="/identity-vault/secure-storage" component={SecureStorage} />
                <DefaultLayout exact path="/identity-vault/password-manager" component={PasswordManager} />
                <DefaultLayout exact path="/monitoring" component={ActiveAlerts} />
                <DefaultLayout exact path="/child-credit-activity" component={ChildCreditActivity} canAccess={!isPrimaryAccount && isCCAMServiceActive()} />
                <DefaultLayout exact path="/monitoring/cases" component={Cases} />
                <DefaultLayout exact path="/credit" component={CreditPage} />
                <DefaultLayout exact path="/credit/:tabName" component={CreditPage} />

                <DefaultLayout exact path="/bcredit/get-started" component={GetStarted} />
                <DefaultLayout exact path="/bcredit/search" component={BusinessSearch} />
                <DefaultLayout exact path="/bcredit/credit-profile-setup" component={BusinessCreditProfileForm} />

                <DefaultLayout exact path="/transactions" component={Transactions} />
                <DefaultLayout exact path="/transactions/financial-account" component={FinancialAccount} />
                <DefaultLayout exact path="/services" component={Services} />
                <DefaultLayout exact path="/resources" component={Resources} />
                <DefaultLayout exact path="/resources/education" component={Education} canAccess={!isBusinessUser} />
                <DefaultLayout exact path="/resources/business-education" component={BusinessEducation} canAccess={isBusinessUser && i18nLang.language === "en"} />
                <DefaultLayout exact path="/resources/calculators" component={Calculators} />
                <DefaultLayout exact path="/resources/security-assessment" component={SecurityAssessment} />
                <DefaultLayout exact path="/resources/security-assessment-wizard" component={SecurityAssessmentWizard} />
                <DefaultLayout exact path="/resources/cyber-risk-profile" component={CyberRiskProfile} />
                <DefaultLayout exact path="/resources/cyber-risk-profile-wizard" component={CyberRiskProfileWizard} />
                <DefaultLayout exact path="/resources/breach-readiness" component={BreachReadiness} canAccess={isBusinessUser} />
                <DefaultLayout exact path="/resources/forms" component={Forms} />
                <DefaultLayout exact path="/resources/downloads" component={Downloads} />
                <DefaultLayout exact path="/resources/junk-mail-and-calls" component={JunkMailAndCalls} canAccess={!isBusinessUser} />
                <DefaultLayout exact path="/resources/breaches-and-scams" component={BreachesAndScams} canAccess={i18nLang.language === "en"} />
                <DefaultLayout exact path="/resources/financial-coaching" component={FinancialCoaching} />
                <DefaultLayout exact path="/resources/loan-calculator" component={LoanCalculator} />
                <DefaultLayout exact path="/resources/ccc-calculator" component={CreditCardComparisonCalculator} />
                <DefaultLayout exact path="/resources/auto-lease-buy-calculator" component={AutoLeaseBuyCalculator} />
                <DefaultLayout exact path="/resources/mortgage-qualification-calculator" component={MortgageQualificationCalculator} />
                <DefaultLayout exact path="/resources/debt-consolidation-calculator" component={DebtConsolidationCalculator} />
                <DefaultLayout exact path="/resources/mortage-refinancing-calculator" component={MortageRefinancingCalculator} />
                <DefaultLayout exact path="/supports" component={Support} />
                <DefaultLayout exact path="/support" component={GeneralSupport} />
                <DefaultLayout exact path="/support/breachSupport" component={BreachSupport} />
                <DefaultLayout exact path="/support/incidentResponse" component={IncidentResponseSupport} />
                <DefaultLayout exact path="/protection" component={RiskProtection} canAccess={isLMSComplete && isLmsActiveService} />
                <LoginLayout exact path="/terms" component={TermsAndConditions} />
                <LoginLayout exact path="/privacy" component={PrivacyPolicy} />
                <LoginLayout exact path="/gdpr" component={EuUsGDPRPolicy} />
                {/* <LoginLayout exact path='/privacy-shield' component={EuUsPrivacyShieldPrivacyPolicy} /> */}
                <LoginLayout exact path="/ccpa" component={CCPA} />
                <DefaultLayout exact path="/manage-account/my-services" component={MyServices} />
                <LoginLayout exact path="/common-definition" component={CommonDefinition} />
                <DefaultLayout exact path="/manage-account/my-account" component={MyAccount} />
                <DefaultLayout exact path="/payment-history" component={PaymentHistory} />
                <LoginLayout exact path="/register/error" component={RegistrationError} />
                <LoginLayout exact path="/social-media-callback" component={SocialMediaCallback} />
                <LoginLayout exact path="/rep-iq-social-media-callback" component={RepIQSocialMediaCallback} />
                <DefaultLayout exact path="/breaches" component={Breaches} />
                <DefaultLayout exact path="/breaches/exposures" component={MyBreachExposure} />
                <DefaultLayout exact path="/breaches/action-plan" component={ActionPlan} />
                <DefaultLayout exact path="/breaches/search-breaches" component={SearchBreaches} />
                <DefaultLayout exact path="/breaches/search-breaches-results" component={SearchBreachesResults} />
                <DefaultLayout exact path="/breaches/breach-details" component={BreachDetails} />
                <DefaultLayout exact path="/breaches/faq" component={BreachFaq} />
                <DefaultLayout exact path="/my-reputation" component={Reputation} />
                <DefaultLayout exact path="/my-reputation-data-sources" component={DataSources} />
                <DefaultLayout exact path="/my-reputation/agreeableness" component={Agreeableness} />
                <DefaultLayout exact path="/my-reputation/emotional-range" component={EmotionalRange} />
                <DefaultLayout exact path="/my-reputation/openness-to-experiences" component={OpennessToExperience} />
                <DefaultLayout exact path="/my-reputation/extraversion" component={Extraversion} />
                <DefaultLayout exact path="/my-reputation/conscientiousness" component={Conscientiousness} />
                <DefaultLayout exact path="/employees" component={Employees} />
                <DefaultLayout exact path="/add-employee" component={AddEmployee} />
                <DefaultLayout exact path="/mav/:tabName" component={MobileAttackView} />
                <LoginLayout exact path="/access-request" component={AccessRequest} />
                <LoginLayout exact path="/sso-terms" component={SSOTermsAndCondition} />
                <LoginLayout exact path="/system-error" component={SystemError} />
                <LoginLayout exact path="/link-expiry" component={LinkExpiry} />
                {/* <Redirect to="/dashboard" /> */}
                <PssLandingRoutes />
                <SalesLandingRoutes />
                <LandingPageRoutes />
            </div>
        </React.Fragment>
    );
};
